import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullscreenImageViewerComponent } from './fullscreen-image-viewer/fullscreen-image-viewer.component';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [FullscreenImageViewerComponent],
  imports: [CommonModule, ImageLoaderModule, MatIconModule, MatButtonModule],
})
export class FullscreenImageViewerModule {}
